import { NavLink, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Home from "./routes/Home";
import Solo from "./routes/Solo";
import Lobby from "./routes/Lobby";
import Room from "./routes/Room";
import Codes from "./routes/Codes";
import CodeEditor from "./routes/CodeEditor";
import HowTo from "./routes/HowTo";
import LangSwitcher from "./components/LangSwitcher";
import FeedbackButton from "./components/FeedbackButton";

export default function App() {
  const { t } = useTranslation();
  return (
    <div className="app-shell">
      <header className="topbar">
        <NavLink to="/" className="brand">
          <img src="/favicon.svg" alt="" className="brand-mark" width={32} height={32} />
          <span className="brand-name">LEXIKON</span>
        </NavLink>
        <nav className="nav">
          <NavLink to="/solo" className={({ isActive }) => (isActive ? "active" : "")}>
            {t("nav.solo")}
          </NavLink>
          <NavLink to="/play" className={({ isActive }) => (isActive ? "active" : "")}>
            {t("nav.play")}
          </NavLink>
          <NavLink to="/codes" className={({ isActive }) => (isActive ? "active" : "")}>
            {t("nav.codes")}
          </NavLink>
          <NavLink to="/how-to-play" className={({ isActive }) => (isActive ? "active" : "")}>
            {t("nav.howto")}
          </NavLink>
        </nav>
        <LangSwitcher />
      </header>
      <main className="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solo" element={<Solo />} />
          <Route path="/play" element={<Lobby />} />
          <Route path="/play/:roomCode" element={<Room />} />
          <Route path="/codes" element={<Codes />} />
          <Route path="/how-to-play" element={<HowTo />} />
          <Route path="/codes/new" element={<CodeEditor />} />
          <Route path="/codes/:codeId/edit" element={<CodeEditor />} />
        </Routes>
      </main>
      <footer className="footer">
        <span>LEXIKON · Komunikon Language System · playtest build</span>
      </footer>
      <FeedbackButton />
    </div>
  );
}
